import { render, staticRenderFns } from "./polistprice.vue?vue&type=template&id=4266f382&scoped=true"
import script from "./polistprice.vue?vue&type=script&lang=js"
export * from "./polistprice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4266f382",
  null
  
)

export default component.exports